import { render, staticRenderFns } from "./categlist.vue?vue&type=template&id=3097d6b5&scoped=true&"
import script from "./categlist.vue?vue&type=script&lang=js&"
export * from "./categlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3097d6b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3097d6b5')) {
      api.createRecord('3097d6b5', component.options)
    } else {
      api.reload('3097d6b5', component.options)
    }
    module.hot.accept("./categlist.vue?vue&type=template&id=3097d6b5&scoped=true&", function () {
      api.rerender('3097d6b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/list/categlist.vue"
export default component.exports